/**
 * Устанавливает cookie с заданными параметрами
 *
 * @param name - Имя cookie
 * @param value - Значение cookie
 * @param days - Количество дней до истечения срока действия (по умолчанию 365)
 *
 * @description
 * Создает cookie с указанным именем и значением, устанавливая срок действия
 * и базовые параметры безопасности:
 * - Path: "/" (доступен на всех страницах)
 * - SameSite: Lax (защита от CSRF-атак)
 * - Срок действия: настраивается параметром days
 *
 * @example
 * // Установка cookie на год (по умолчанию)
 * setCookie('user_id', '12345');
 *
 * @example
 * // Установка cookie на 30 дней
 * setCookie('session_token', 'abc123', 30);
 */
export const setCookie = (
  name: string,
  value: string,
  days: number = 365,
): void => {
  try {
    if (typeof document === 'undefined') {
      return;
    }

    const expires = new Date();

    expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000);

    document.cookie = `${name}=${value};expires=${expires.toUTCString()};path=/;SameSite=Lax`;
  } catch (error) {
    console.warn('Failed to set cookie:', error);
  }
};
